import Navbar from "../../components/sections/Navbar";
import Footer from "../../components/sections/Footer";
import { Reveal } from "../../components/Reveal";

export const LegalLayout = ({ kicker, title, updated, children, testid }) => (
  <div className="min-h-screen bg-white text-slate-900" data-testid={testid}>
    <Navbar />
    <main className="pt-36 lg:pt-44 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1565C0]">{kicker}</p>
          <h1 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">{title}</h1>
          <p className="mt-4 text-sm text-slate-400">Ultima actualizare: {updated}</p>
        </Reveal>
        <div className="mt-12 space-y-6">{children}</div>
      </div>
    </main>
    <Footer />
  </div>
);

export const LegalSection = ({ title, children, testid }) => (
  <Reveal>
    <section data-testid={testid} className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
      <h2 className="font-display font-semibold text-xl text-slate-900">{title}</h2>
      <div className="mt-4 space-y-3 text-slate-600 leading-relaxed text-[15px]">{children}</div>
    </section>
  </Reveal>
);

export default LegalLayout;
